import { render, staticRenderFns } from "./sendLinkToEmail.vue?vue&type=template&id=5d538c53&scoped=true&"
import script from "./sendLinkToEmail.vue?vue&type=script&lang=js&"
export * from "./sendLinkToEmail.vue?vue&type=script&lang=js&"
import style0 from "./sendLinkToEmail.vue?vue&type=style&index=0&id=5d538c53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d538c53",
  null
  
)

export default component.exports